import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class Orders extends PaginatedStore {

  constructor(scope) {
    super(new Connection('orders', scope))
  }

}



// WEBPACK FOOTER //
// client/stores/orders.js